(() => {
  function mount(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('.ts-gallery-main');
    const slides = [...track.children];
    const thumbs = [...root.querySelectorAll('.ts-gallery-thumb')];
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    let current = 0;
    function load(index) {
      const img = slides[index]?.querySelector('img[data-gallery-src]');
      if (!img) return;
      if (img.dataset.gallerySrcset) img.srcset = img.dataset.gallerySrcset;
      img.src = img.dataset.gallerySrc;
      delete img.dataset.gallerySrc;
      delete img.dataset.gallerySrcset;
    }
    function update(index) {
      current = index;
      load(index);
      thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    function go(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      update(index);
      track.scrollTo({left: index * track.clientWidth, behavior: 'instant'});
      if (thumbs[index]) {
        const parent = thumbs[index].parentElement;
        parent.scrollTo({left: thumbs[index].offsetLeft - parent.offsetLeft, behavior: 'instant'});
      }
    }
    thumbs.forEach((button, index) => button.addEventListener('click', () => go(index)));
    prev?.addEventListener('click', () => go(current - 1));
    next?.addEventListener('click', () => go(current + 1));
    track.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      if (index !== current && index >= 0 && index < slides.length) update(index);
    }, {passive: true});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    new ResizeObserver(() => {track.scrollLeft = current * track.clientWidth;}).observe(track);
    update(0);
  }
  document.querySelectorAll('[data-ts-gallery]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ts-gallery]').forEach(mount));
})();
